<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6">
        <h6>{{ stepTitle }}</h6>
      </div>
      <div class="col-md-6" *ngIf="siteId !== ''">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      Static Load Tree Configuration
      <a
        href="#"
        data-toggle="tooltip"
        data-placement="right"
        data-html="true"
        title="Configuration made for 'Static Load Tree' reflect as Load Tree in the portal"
      >
        <i class="fa fa-info-circle" aria-hidden="true"></i>
      </a>
    </div>
  </div>
  <div class="row" *ngIf="treeData === undefined || treeData.length <= 0">
    <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
      <button class="btn btn-primary" (click)="initTree(treeType.STATIC_TREE)">
        Initiate Tree
      </button>
    </div>
  </div>

  <div class="row">
    <div style="max-height: 650px; overflow-y: scroll">
      <mat-tree
        #tree
        [dataSource]="dataSource"
        [(treeControl)]="treeControl"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
      >
        <mat-tree-node
          class="site-tree-node"
          *matTreeNodeDef="let node"
          cdkDrag
          [cdkDragData]="node"
          (mouseenter)="dragHover(node)"
          (mouseleave)="dragHoverEnd()"
          (cdkDragStarted)="dragStart()"
          (cdkDragReleased)="dragEnd()"
          matTreeNodeToggle
          matTreeNodePadding
          (click)="activeNode = node"
        >
          <div class="row" style="width: 100%">
            <div class="col-md-8">
              <button
                type="button"
                bciprimarybutton
                (click)="$event.preventDefault()"
                disabled
                style="border: none"
              ></button>
              <mat-label (click)="featureLeafItemSelectionToggle(node)">{{
                node.title
              }}</mat-label>
            </div>
            <div class="col-md-4" style="text-align: right">
              <button
                id="edit_{{ node.title }}"
                class="button-primary"
                bciprimarybutton
                (click)="editNode(node, treeType.STATIC_TREE)"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="edit icon"
                    class="bosch-ic-edit"
                    style="width: max-content"
                  ></mat-icon>
                </span>
              </button>
              &nbsp;
              <button
                type="button"
                id="new_{{ node.title }}"
                class="button-primary"
                bciprimarybutton
                (click)="newSubItem(node, treeType.STATIC_TREE)"
                [disabled]="node.nodeType === 'LOAD'"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="add icon"
                    class="bosch-ic-add"
                    style="width: max-content"
                  ></mat-icon>
                </span>
              </button>
              &nbsp;
              <button
                class="button-primary"
                bciprimarybutton
                (click)="removeNodeItem(node, treeType.STATIC_TREE)"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="weather icon"
                    class="bosch-ic-abort-frame"
                    style="width: max-content"
                  ></mat-icon>
                </span>
              </button>
            </div>
          </div>
        </mat-tree-node>

        <mat-tree-node
          class="site-tree-node"
          *matTreeNodeDef="let node; when: hasChild"
          cdkDrag
          [cdkDragData]="node"
          (mouseenter)="dragHover(node)"
          (mouseleave)="dragHoverEnd()"
          (cdkDragStarted)="dragStart()"
          (cdkDragReleased)="dragEnd()"
          matTreeNodePadding
          (click)="activeNode = node"
        >
          <div class="row" style="width: 100%">
            <div class="col-md-7">
              <button
                type="button"
                bciprimarybutton
                (click)="$event.preventDefault()"
                matTreeNodeToggle
                [attr.aria-label]="'toggle ' + node.filename"
                style="border: none"
              >
                <mat-icon
                  *ngIf="treeControl.isExpanded(node)"
                  fontIcon="Bosch-Ic-arrow-expand-down"
                ></mat-icon>
                <mat-icon
                  *ngIf="!treeControl.isExpanded(node)"
                  fontIcon="Bosch-Ic-arrow-expand-right"
                ></mat-icon>
              </button>
              <mat-label>{{ node.title }}</mat-label>
            </div>
            <div class="col-md-5" style="text-align: right">
              <button
                class="button-primary"
                bciprimarybutton
                (click)="editNode(node, treeType.STATIC_TREE)"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="edit icon"
                    class="bosch-ic-edit"
                    style="width: max-content"
                  ></mat-icon>
                </span>
              </button>
              &nbsp;
              <button
                type="button"
                class="button-primary"
                bciprimarybutton
                (click)="newSubItem(node, treeType.STATIC_TREE)"
                [disabled]="node.nodeType === 'LOAD'"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="add icon"
                    class="bosch-ic-add"
                    style="width: max-content"
                  ></mat-icon>
                </span>
              </button>
              &nbsp;

              <button
                class="button-primary"
                bciprimarybutton
                (click)="removeNodeItem(node, treeType.STATIC_TREE)"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="weather icon"
                    class="bosch-ic-abort-frame"
                    style="width: max-content"
                  ></mat-icon>
                </span>
              </button>
            </div>
          </div>
        </mat-tree-node>
      </mat-tree>
    </div>
  </div>

  <!-- Load ON View Configuration -->
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      Apply the above configuration to Load -ON View Page:
      <mat-radio-button
        #flowYes
        style="margin-top: 1em"
        value="yes"
        (change)="copyToLoadOnViewRadioChange('yes')"
        >Yes</mat-radio-button
      >
      <mat-radio-button
        #flowNo
        style="margin-top: 1em"
        value="no"
        (change)="copyToLoadOnViewRadioChange('no')"
        >No</mat-radio-button
      >
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      Load ON View Configuration
      <a
        href="#"
        data-toggle="tooltip"
        data-placement="right"
        data-html="true"
        title="Configuration made for 'Load ON View' reflect in 'Load ON View' tab of Landing Page"
      >
        <i class="fa fa-info-circle" aria-hidden="true"></i>
      </a>
    </div>
  </div>

  <div
    class="row"
    *ngIf="loadONTreeData === undefined || loadONTreeData.length <= 0"
  >
    <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
      <button class="btn btn-primary" (click)="initTree(treeType.LOAD_ON_TREE)">
        Initiate Tree
      </button>
    </div>
  </div>

  <div class="row">
    <app-load-on-view-configuration
      [data]="loadONTreeData"
      [treeConfigSubject]="callLoadOnSubject"
      [processAndLoads]="processAndLoads"
      [siteId]="siteId"
      (updateBackEvent)="updateBackFromLoadOnView($event)"
    ></app-load-on-view-configuration>
  </div>

  <!-- Inverter View Configuration -->
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      Apply the Static tree configuration to Inverter View Page:

      <mat-radio-button
        #inverterYes
        style="margin-top: 1em"
        value="yes"
        (change)="copyToInverterViewRadioChange('yes')"
        >Yes</mat-radio-button
      >
      <mat-radio-button
        #inverterNo
        style="margin-top: 1em"
        value="no"
        (change)="copyToInverterViewRadioChange('no')"
        >No</mat-radio-button
      >
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      Inverter View Configuration
      <a
        href="#"
        data-toggle="tooltip"
        data-placement="right"
        data-html="true"
        title="Configuration made for 'Inverter View' reflect in 'Inverter View' tab of Solar Page"
      >
        <i class="fa fa-info-circle" aria-hidden="true"></i>
      </a>
    </div>
  </div>

  <div
    class="row"
    *ngIf="inverterTreeData === undefined || inverterTreeData.length <= 0"
  >
    <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
      <button
        class="btn btn-primary"
        (click)="initTree(treeType.INVERTER_TREE)"
      >
        Initiate Tree
      </button>
    </div>
  </div>

  <div class="row">
    <app-inverter-view-configuration
      [data]="inverterTreeData"
      [treeConfigSubject]="callInverterSubject"
      [processAndLoads]="processAndLoads"
      [siteId]="siteId"
      (updateBackEvent)="updateBackFromInverterView($event)"
    ></app-inverter-view-configuration>
  </div>

  <!-- Generic Tree View Configuration -->
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      Apply the Static tree configuration to Generic Dashboard View Page:
      <mat-radio-button
        #transformYes
        style="margin-top: 1em"
        value="yes"
        (change)="copyToTransformerViewRadioChange('yes')"
        >Yes</mat-radio-button
      >
      <mat-radio-button
        #transformNo
        style="margin-top: 1em"
        value="no"
        (change)="copyToTransformerViewRadioChange('no')"
        >No</mat-radio-button
      >
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      Generic Tree View Configuration
      <a
        href="#"
        data-toggle="tooltip"
        data-placement="right"
        data-html="true"
        title="Configuration made for 'Generic Tree View' reflect in 'Generic Tree View' tab of Generic Dashboard Page"
      >
        <i class="fa fa-info-circle" aria-hidden="true"></i>
      </a>
    </div>
  </div>

  <div
    class="row"
    *ngIf="genericTreeData === undefined || genericTreeData.length <= 0"
  >
    <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
      <button class="btn btn-primary" (click)="initTree(treeType.GENERIC_TREE)">
        Initiate Tree
      </button>
    </div>
  </div>

  <div class="row">
    <app-generic-tree-view-configuration
      [data]="genericTreeData"
      [treeConfigSubject]="callGenericSubject"
      [processAndLoads]="processAndLoads"
      [siteId]="siteId"
      (updateBackEvent)="updateBackFromGenericView($event)"
    ></app-generic-tree-view-configuration>
  </div>

  <mat-action-row>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
      <button
        (click)="previousStep($event)"
        class="button-primary"
        bciprimarybutton
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Previous
      </button>
      <button
        type="submit"
        class="button-primary"
        bciprimarybutton
        style="margin-left: 3px"
        (click)="saveTreeConfiguration()"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-checkmark-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Save
      </button>

      <button
        (click)="nextStep($event)"
        class="button-primary"
        bciprimarybutton
        style="margin-left: 3px"
      >
        Next
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-right-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
      </button>
    </div>
  </mat-action-row>
</mat-expansion-panel>
